/**
 * 将后端 PascalCase 响应统一转换为 camelCase，消除大小写不匹配问题。
 * 后端 JSON 配置了 PropertyNamingPolicy = null，返回 PascalCase 字段。
 * 前端统一用 camelCase 读取。
 */
export function normalizeKeys(obj) {
  if (obj === null || obj === undefined) return obj
  if (Array.isArray(obj)) return obj.map(normalizeKeys)
  if (typeof obj !== 'object') return obj

  const result = {}
  for (const key of Object.keys(obj)) {
    // 将首字母转小写：PascalCase → camelCase
    // OperatorID → operatorID, ChildFolder → childFolder, Data → data
    const camelKey = key.charAt(0).toLowerCase() + key.slice(1)
    result[camelKey] = normalizeKeys(obj[key])
  }
  return result
}
